var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoAndPic = function SvgVideoAndPic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 111 121"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    clipPath: "url(#video-and-pic_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.419,
    d: "M73.743 69.5h-57.27a3.973 3.973 0 0 0-3.973 3.973v41.054a3.973 3.973 0 0 0 3.973 3.973h57.27a3.973 3.973 0 0 0 3.973-3.973v-9.536c0-1.103 1.27-1.723 2.14-1.044L96.36 116.83c.87.679 2.139.059 2.139-1.044V72.214c0-1.103-1.27-1.723-2.14-1.044L79.856 84.053c-.87.679-2.139.06-2.139-1.044v-9.536a3.973 3.973 0 0 0-3.973-3.973Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 29,
    y: 2,
    strokeWidth: 3,
    rx: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m28.922 37.547 18.05-19 16.625 20.9 9.975-9.975 9.5 10.45"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.353,
    cy: 14.752,
    r: 5.15,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "video-and-pic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h110v120H.5z"
  })))));
};
export default SvgVideoAndPic;